<template>
  <el-dialog class="modify-password-dialog-container" :class="{weak:mode===1}" title="修改密码"
             :visible="visible" @close="close" width="500px">
    <p v-if="mode===1" class="tips">您当前账户的密码强度较低，存在风险，请修改密码后使用</p>
    <p v-if="mode===2" class="tips">您当前账户的密码已过期，请修改密码后使用</p>
    <div>
      <span
            style="display: inline-block;float: left;text-align: left; margin-bottom: 10px;">原密码</span>
    </div>
    <el-input placeholder="请输入原密码" type="password" maxlength="30" v-model="oldPassword" clearable
              :readonly="passwordReadonly" autocomplete='off' @focus="passwordReadonly=false"
              @blur="passwordReadonly=false">
    </el-input>

    <div>
      <span
            style="display: inline-block;float: left;text-align: left; margin-bottom: 10px; margin-top: 10px;">新密码(由
        8-20位大小字母、数字、特殊符号组成)</span>
    </div>
    <div style="position: relative;">
      <el-input placeholder="请输入新密码" :type="passwordType" maxlength="30" v-model="newPassword" clearable
                :readonly="newPasswordReadonly" autocomplete='off'
                @focus="newPasswordReadonly=false" @blur="newPasswordReadonly=false">

      </el-input>
      <i :class="['fontFamily',{'ryx-chakanmima':passwordType==='password'},{'ryx-yincangmima':passwordType==='text'},'passWordIcon']"
         @click="passwordTypeChange"></i>
    </div>
    <div class="psd-level">
      <span :class="{red:passwordLevel===1}"
            style="display: inline-block;width: 34px;height: 100%;float: left;line-height: 27px;">低</span>
      <span :class="{orange:passwordLevel===2||passwordLevel===3}"
            style="display: inline-block;width: 33px;height: 100%;line-height: 27px;">中</span>
      <span :class="{green:passwordLevel===4}"
            style="display: inline-block;width: 33px;height: 100%;float: right;line-height: 27px;">高</span>
    </div>
    <div>
      <span
            style="display: inline-block;float: left;text-align: left; margin-bottom: 10px; margin-top: 10px;">重复新密码</span>
    </div>
    <div style="position: relative;">
      <el-input placeholder="请重复输入新密码" :type="reusePasswordType" maxlength="30" v-model="confirmedPassword"
                clearable></el-input>
      <i :class="['fontFamily',{'ryx-chakanmima':reusePasswordType==='password'},{'ryx-yincangmima':reusePasswordType==='text'},'reusePassWordIcon']"
         @click="reusePasswordTypeChange"></i>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">返 回</el-button>
      <el-button type="primary" @click="submitButtonClicked">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import PasswordUtils, { publicKey } from '@/utils/password'
import JSEncrypt from 'jsencrypt/bin/jsencrypt'

export default {
  name: 'modifyPasswordDialog',
  props: {
    mode: 0,
    visible: Boolean
  },
  data () {
    return {
      oldPassword: '',
      passwordReadonly: true,
      newPasswordReadonly: true,
      newPassword: '',
      confirmedPassword: '',
      passwordType: 'password',
      reusePasswordType: 'password'
    }
  },
  computed: {
    passwordLevel () {
      return PasswordUtils.testPasswordLevel(this.newPassword)
    }
  },
  methods: {
    reusePasswordTypeChange () {
      this.reusePasswordType =
        this.reusePasswordType === 'password' ? 'text' : 'password'
    },
    passwordTypeChange () {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    },
    close () {
      this.$emit('update:visible', false)
    },
    async submitButtonClicked () {
      // else if (this.newPassword === '') {
      //   this.$message({
      //     type: 'warning',
      //     message: '请重复输入新密码！'
      //   })
      // }
      if (this.oldPassword === '') {
        this.$message({
          type: 'warning',
          message: '旧密码未填写！'
        })
      } else if (this.newPassword === '') {
        this.$message({
          type: 'warning',
          message: '新密码未填写！'
        })
      } else if (
        this.newPassword.length < 8 ||
        this.newPassword.length > 20 ||
        this.passwordLevel < 4
      ) {
        this.$message({
          type: 'warning',
          message: '新密码必须由 8-20位大小字母、数字、特殊符号组成!'
        })
      } else if (this.confirmedPassword === '') {
        this.$message({
          type: 'warning',
          message: '重复新密码未填写！'
        })
      } else if (this.newPassword !== this.confirmedPassword) {
        this.$message({
          type: 'warning',
          message: '两次输入的密码不一样，请重新输入！'
        })
      } else {
        const jse = new JSEncrypt()
        jse.setPublicKey(publicKey) // 配置公钥
        let password = jse.encrypt(this.newPassword) // 加密密码
        let url = sessionStorage.getItem('E-User-Token')
          ? 'user/updatePassword'
          : 'user/updatePasswordNoLogin'
        try {
          await this.$https.axios({
            loading: true,
            method: 'post',
            url,
            data: {
              password: this.$md5(this.oldPassword),
              newPassWord: password,
              username: sessionStorage.getItem('user_name')
            }
          })
          this.$message.success('密码修改成功！')
          this.close()
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 500)
        } catch (e) {
          console.log(e)
        }
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmedPassword = ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.modify-password-dialog-container {
  .reusePassWordIcon {
    position: absolute;
    right: 6px;
    cursor: pointer;
    top: 47px;
  }
  .passWordIcon {
    position: absolute;
    right: 106px;
    cursor: pointer;
    top: 47px;
  }
  p.tips {
    margin-bottom: 7px;
    color: #02a7f0;
  }
  /deep/ .el-dialog {
    .el-dialog__header {
      text-align: left;
      font-size: 14px;
      font-weight: 600;
    }
    .el-dialog__title {
      display: inline-block;
      width: 76px;
      height: 25px;
      line-height: 25px;
    }
    .el-dialog__body {
      display: block;
      position: relative;
      height: 230px;
      padding: 0px 20px 10px;
      .psd-level {
        display: inline-block;
        width: 100px;
        height: 27px;
        position: absolute;
        top: 113px;
        right: 24px;
        background-color: #f1f1f1;
        border-radius: 3px;
        overflow: hidden;
        span {
          text-align: center;
        }
        .red {
          background-color: #ff4949;
          color: #fff;
        }
        .orange {
          background-color: #ff9b3a;
          color: #fff;
        }
        .green {
          background-color: #29c856;
          color: #fff;
        }
      }
    }
  }
  &.weak /deep/ .el-dialog {
    .el-dialog__body {
      height: 250px;
      .psd-level {
        top: 140px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modifyPasswordDialog.vue